import { render } from "./footer.vue?vue&type=template&id=d11a3876&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=d11a3876&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d11a3876"]])

export default __exports__